<script setup>
  import { useRoute } from 'vue-router'

  import { computed, ref, watch } from 'vue'

  import MainLayout from '@/features/layout/MainLayout.vue'
  import { dashboardLayoutHeaderRightAddItems } from '@/features/layout/components/constants/dashboardLayoutHeaderRightAddItems.js'
  import { useAdminSidebarMenuLinks } from '@/features/layout/components/constants/useAdminSidebarMenuLinks.js'
  import { useHeaderRightActions } from '@/features/layout/components/utils/useHeaderRightActions.js'
  import { useImpersonationLocation } from '@/features/layout/components/utils/useImpersonationLocation.js'
  import WelcomeToClubModal from '@/features/layout/welcomeToClubModal/WelcomeToClubModal.vue'
  import { finishClubImpersonation, useActiveClub } from '@/features/router/useActiveClub.js'

  import { useAuthStore } from '../auth/useAuthStore'
  import { getIsImpersonation } from '../router/useActiveClub'
  import { useIsSuperAdmin } from '../superAdmin/useIsSuperAdmin'
  import { useToaster } from '../ui/toaster/useToaster'

  const { activeClub } = useActiveClub()

  const { rightItems } = dashboardLayoutHeaderRightAddItems()

  const menu = ref()

  function menuToggle(event) {
    menu.value.toggle(event)
  }

  const isSuperAdmin = useIsSuperAdmin()
  const authStore = useAuthStore()

  const toaster = useToaster()

  const impersonationLocation = useImpersonationLocation()
  function handleClickSuperAdmin() {
    if (getIsImpersonation(authStore.myDetails)) {
      finishClubImpersonation(null)

      toaster.success({
        title: 'Impersonation stopped',
        detail: 'You stopped impersonating a club',
      })

      impersonationLocation.reset()
      window.location.href = '/super-admin'
    } else {
      impersonationLocation.reset()
      window.location.href = '/super-admin'
      toaster.success({
        title: 'Redirecting to super admin',
      })
    }
  }

  useHeaderRightActions([
    {
      label: 'common.add',
      icon: 'pi pi-plus',
      onClick: menuToggle,
      attrs: {
        class: 'header-right-add-button',
      },
    },
    isSuperAdmin
      ? {
          label: 'common.superAdmin',
          icon: 'pi pi-cog',
          onClick: handleClickSuperAdmin,
          attrs: {
            class: 'header-right-super-admin-button',
          },
        }
      : null,
  ])

  const menuLinks = useAdminSidebarMenuLinks()

  const route = useRoute()

  function setShowSidebar(showSidebarParam) {
    return showSidebarParam === undefined ? true : showSidebarParam
  }

  const showSidebarMetaValue = ref(setShowSidebar(route.meta.showSidebar))

  watch(
    () => route.meta.showSidebar,
    value => {
      showSidebarMetaValue.value = setShowSidebar(value)
    },
  )

  const hamburgerTitle = computed(() => {
    function normalize(label) {
      if (label === 'undefined') {
        return null
      }

      return label
    }

    return normalize(activeClub.previewName) || activeClub.name || 'N/A'
  })
</script>

<template>
  <WelcomeToClubModal />
  <Menu id="overlay_menu" ref="menu" :model="rightItems" :popup="true" />

  <MainLayout
    :hamburger-title="hamburgerTitle"
    :sidebar-links="menuLinks"
    :show-sidebar="showSidebarMetaValue"
  />
</template>

<style lang="scss" scoped></style>
